import React from 'react'
import useSiteMetadata from './SiteMetaData'
import { withPrefix } from 'gatsby'
import { Helmet } from "react-helmet"


const PageSeo = ({ 
  pageTitle ,
  pageDescription
}) => {

  let { title, description, author, link, keywords } = useSiteMetadata()

  pageTitle = pageTitle || title
  pageDescription = pageDescription || description

  const bannerImage = link + "/assets/banner.png"

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: "en"
        }}
        title={pageTitle}
        titleTemplate={pageTitle!==title ? `%s | ${title}` : null}
      >
        <meta name="author" content={author} />
        <meta name={"description"} content={pageDescription} />
        <meta name="keywords" content={keywords.join(", ")} />
        <meta charSet="utf-8" />
        <meta name="theme-color" content="#663399" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={link} />
        <meta property="og:site_name" content={title} />
        <meta
          property="og:image"
          content={bannerImage}
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description}/>
        <meta name="twitter:image" content={bannerImage}/>

        {/* Schema.org for Google */}
        <meta itemProp="name" content={title} />
        <meta itemProp="description" content={description} />
        <meta itemProp="image" content={bannerImage} />

        <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png" />
        <link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="/apple-icon-114x114.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="/apple-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="/apple-icon-144x144.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="/apple-icon-152x152.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="192x192"  href="/android-icon-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="manifest" href="/manifest.json" />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />

{/*        <script src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js" />*/}
        <link
          rel="stylesheet"
          type="text/css"
          charSet="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.15.4/css/all.css"
          integrity="sha384-DyZ88mC6Up2uqS4h/KRgHuoeGwBcD4Ng9SiP4dIRy0EXTlnuz47vAwmeGwVChigm"
          crossOrigin="anonymous"
        />

        <meta name="viewport" content="width=device-width, initial-scale = 1.0,
          maximum-scale=1.0, user-scalable=no" />
        <script
          type="text/javascript"
          src="/js/clarity.js"
        />
        <script
          type="text/javascript"
          src="/js/zoho.js"
        />
      </Helmet>
    </>
  )
}

export default PageSeo
